/**
 * `BriefSectionError` — per-section fallback when `useBriefSectionViewer`
 * returns `null` (malformed TipTap JSON, missing content, etc.).
 *
 * Lightweight inline error so the rest of the brief renders normally.
 */
import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';

interface BriefSectionErrorProps {
  /** Section name shown to anchor the error to a specific block. */
  name: string;
}

export function BriefSectionError(props: BriefSectionErrorProps) {
  const { t } = useTranslation('projects');

  return (
    <Empty role="status" data-testid="brief-section-error">
      <EmptyHeader>
        <EmptyTitle>
          {t('projectBriefDetail.briefSectionError.cannotDisplaySection', { name: props.name })}
        </EmptyTitle>
        <EmptyDescription>
          {t('projectBriefDetail.briefSectionError.theSectionContentIsIn')}
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
